var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('div',{staticClass:"pb-32 bg-gray-800"},[_c('nav-bar')],1):_vm._e(),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }